import { render, staticRenderFns } from "./OrderExtendList.vue?vue&type=template&id=71c5103a&scoped=true&"
import script from "./OrderExtendList.vue?vue&type=script&lang=js&"
export * from "./OrderExtendList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c5103a",
  null
  
)

export default component.exports